import { makeStyles, shorthands } from '@fluentui/react-components';

export const useConversationRatingsPageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        ...shorthands.overflow('hidden'),
    },
    centerContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
    },
});
